import React from 'react';
import { cn } from '../utils/cn';
export const Checkbox = React.forwardRef(function Checkbox(
  { label, description, error, indeterminate, className, id, ...props },
  ref,
) {
  const checkboxId = id || React.useId();
  const errorId = `${checkboxId}-error`;
  const internalRef = React.useRef(null);
  const setRefs = React.useCallback(
    (node) => {
      internalRef.current = node;
      if (typeof ref === 'function') ref(node);
      else if (ref) ref.current = node;
    },
    [ref],
  );
  React.useEffect(() => {
    if (internalRef.current) {
      internalRef.current.indeterminate = indeterminate ?? false;
    }
  }, [indeterminate]);
  return (
    <div className="flex items-start gap-2">
      <input
        ref={setRefs}
        id={checkboxId}
        type="checkbox"
        className={cn(
          'mt-0.5 h-4 w-4 shrink-0 rounded border-edge text-fg',
          'focus:ring-2 focus:ring-primary-500/25 focus:ring-offset-0',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          error && 'border-danger-500',
          className,
        )}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : undefined}
        {...props}
      />
      {(label || description) && (
        <div>
          {label && (
            <label htmlFor={checkboxId} className="text-sm font-medium text-fg-secondary">
              {label}
            </label>
          )}
          {description && <p className="text-sm text-fg-tertiary">{description}</p>}
          {error && (
            <p id={errorId} className="mt-0.5 text-sm text-danger-600" role="alert">
              {error}
            </p>
          )}
        </div>
      )}
    </div>
  );
});
